export function AppAnalyticsRun($rootScope,
    $location,
    $window,
    Page
) {
    let loadedTimeout,
        firstLoad = true,
        navStart = null;

    $rootScope.$on('$stateChangeStart', function() {
        if (navStart === null && $window.performance) {
            navStart = firstLoad ? $window.performance.timing.navigationStart : (new Date()).getTime();
        }
        if (loadedTimeout) {
            $window.clearTimeout(loadedTimeout);
        }
    });

    if ($window.newrelic && $window.performance) {
        $rootScope.$on('$viewContentLoaded', function() {
            const lastEnd = (new Date()).getTime();
            $window.clearTimeout(loadedTimeout);
            loadedTimeout = $window.setTimeout(function() {
                if (Page.hideGlobalSpinner) {
                    if (firstLoad) {
                        $window.newrelic.finished(lastEnd);
                    }
                    $window.newrelic.addPageAction('angular_page_load', {
                        time: lastEnd - navStart,
                        firstLoad,
                        networkTime: firstLoad ? ($window.performance.timing.responseStart - $window.performance.timing.navigationStart) : 0,
                        pageName: $location.path().replace(/\/[0-9]+/g, '/*').toLowerCase()
                    });
                    navStart = null;
                    firstLoad = false;
                }
            }, 1000);
        });
    }
}
AppAnalyticsRun.$inject = [
    '$rootScope',
    '$location',
    '$window',
    'Page'
];
